<div class="usuarios-container px-3 py-4">
  <h5 class="mb-3">{{ 'ultimos-usuarios.titulo' | translate }}</h5>
  <div class="usuarios-table">
    <!-- Encabezados de la tabla -->
    <app-table
      *ngIf="true"
      [datos]="usuariosFormateados"
      [columnas]="columnasUltimosUsuarios"
      [paginacion]="true"
      [paginaActual]="paginaActual"
      [totalPaginas]="totalPaginas"
      [tamano]="tamanoPagina"
      (evento)="buscarUltimosUsuarios($event)"
      [multipleSelection]="false"
      [idColumn]="'id'"></app-table>
  </div>
</div>
